import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RemoteService } from 'app/services/remote.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { JwtHelperService } from "@auth0/angular-jwt";
import { NotifierService } from 'angular-notifier';
import { LocalStorageService } from 'ngx-store';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  changePassword: FormGroup;
  formSumitAttempt: boolean;
  showMessageMatchedPwd: string;
  helper = new JwtHelperService();
  token: any;
  decodedToken: any;
  constructor(private fb: FormBuilder,
    private router: Router,
    private remoteService: RemoteService,
    private route: ActivatedRoute,
    private notifierService: NotifierService,
    private ls: LocalStorageService) { }

  ngOnInit() {
    this.changePassword = this.fb.group({
      newPassword: ['', Validators.required],
      confirmNewPassword: ['', Validators.required]
    })
    this.remoteService.scrollingtoNavbar();
    if (this.ls.get('access_token')) {
      return this.remoteService.userNavigateTodashboard();
    }
    this.queryParam();
  }

  jwtToken() {
    this.decodedToken = this.helper.decodeToken(this.token);
    // this.expirationDate = this.helper.getTokenExpirationDate(tkn);
    // this.isExpired = this.helper.isTokenExpired(tkn);
  }

  isFieldValid(field: string) {
    return (
      (!this.changePassword.get(field).valid && this.changePassword.get(field).touched) ||
      (this.changePassword.get(field).untouched && this.formSumitAttempt)
    );
  }

  onSubmit() {
    this.formSumitAttempt = true;
  }

  submit() {
    if (this.showMessageMatchedPwd == "Not matched") {
      return this.notifierService.notify('error', 'The passwords you entered did not match.');
    }
    if (this.changePassword.valid) {
      const payload = {
        email: this.decodedToken.aud,
        token: this.token,
        password: this.changePassword.value.newPassword
      }
      this.remoteService.changePassword(payload).subscribe(res => {
        this.notifierService.notify('success', 'Your password has been changed successfully.');
        this.router.navigate(['/login']);
      }, (error) => {
        this.remoteService.errorFunction(error);
      })
    } else {
      this.notifierService.notify('error', 'Invalid Inputs!');
    }
  }

  queryParam() {
    this.route
      .queryParams
      .subscribe(params => {
        this.token = params.jwtToken;
        this.jwtToken();
      });
  }

  keyupPassword() {
    if (this.changePassword.value.newPassword !== undefined && this.changePassword.value.newPassword !== '' &&
      this.changePassword.value.newPassword !== null && this.changePassword.value.confirmNewPassword !== undefined &&
      this.changePassword.value.confirmNewPassword !== '' && this.changePassword.value.confirmNewPassword !== null) {
      if (this.changePassword.value.newPassword == this.changePassword.value.confirmNewPassword) {
        this.showMessageMatchedPwd = 'Matched password'
      } else {
        this.showMessageMatchedPwd = 'Not matched'
      }
    }
  }

  removeSpaces() {
    if ((this.changePassword.value.newPassword).trim() === '' || (this.changePassword.value.newPassword).trim() === null || (this.changePassword.value.newPassword).trim() === undefined) {
      this.changePassword.patchValue({ newPassword: (this.changePassword.value.newPassword).trim() });
    }
    if ((this.changePassword.value.confirmNewPassword).trim() === '' || (this.changePassword.value.confirmNewPassword).trim() === null || (this.changePassword.value.confirmNewPassword).trim() === undefined) {
      this.changePassword.patchValue({ confirmNewPassword: (this.changePassword.value.confirmNewPassword).trim() });
    }
  }
}
